var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"70%"}},[_c('div',{staticClass:"operationPage"},[_c('div',[_c('video',{staticStyle:{"background":"#000","width":"100%","height":"100%"},attrs:{"controls":"","preload":"auto","autoplay":"","src":"https://mpv.videocc.net/a21ba01cc4/5/a21ba01cc4ff7b87bb7bf8215b8c91d5_3.mp4"}})])])])
}]

export { render, staticRenderFns }